<template>
    <div class="shopping-wrap ptb-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-12 order-lg-1 order-1">
                    <div
                        class="shopping-img-wrap"
                        style="border-radius: 12px; overflow: hidden">
                        <img
                            v-if="this.image"
                            :src="this.image"
                            alt="Image" />
                    </div>
                </div>
                <div class="col-lg-6 col-12 order-lg-2 order-2">
                    <div class="shopping-content">
                        <img
                            src="../../assets/images/shopping/shopping-shape-1.png"
                            alt="Image"
                            class="shopping-shape-one moveHorizontal" />
                        <img
                            src="../../assets/images/shopping/shopping-shape-2.png"
                            alt="Image"
                            class="shopping-shape-two bounce" />
                        <div class="content-title style1" style="padding: 0px 25px !important;">
                            <h2 class="header-blue-tf-color text-center">{{ this.title }}</h2>
                            <p style="text-align: justify; padding: 0px !important;">
                                From <strong>May 15 to May 23, 2025</strong>, all existing and new TOTAL 
                                customers can take advantage of special vehicle financing rates ranging from 
                                <strong>9.00% to 11.00% APR</strong>* for a loan term of 60 months. The nominal 
                                rate varies between <strong>7.24% and 9.02%</strong>. TOTAL reserves the right 
                                to modify, extend, or terminate the campaign at any time. During the loan term, 
                                All-Risk Insurance is mandatory, and the financed vehicle will remain under 
                                TOTAL’s fiduciary ownership. A prepayment penalty of <strong>7.50% of the outstanding balance</strong>, 
                                with a minimum fee of <strong>AWG 350.00</strong>, applies for early repayment. For complete terms and conditions, 
                                please visit our website.
                                <br><br>
                                <i style="font-size: 0.9rem;">* The applicable APR is determined based on the client’s risk profile and creditworthiness as assessed by TOTAL.</i>
                            </p>
                            <router-link
                                to="/terms-and-conditions"
                                class="btn style1"
                                style="float: left; margin-top: 18px;"
                                >Go to terms and conditions
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AutoNights',
    props: {
        title: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            image: require("../../assets/images/campaigns/campaign-auto-nights.jpg"),
        };
    },
}
</script>